import { ReportGroupGeneratedEntity } from "./generated/ReportGroupGeneratedEntity";

export abstract class ReportGroupEntity extends ReportGroupGeneratedEntity {
    // Comment to preserve new line
}
